import styled from "styled-components";

export default styled.div`
  .not-all-day-picker {
    display: flex;
    flex-flow: column nowrap;
    gap: 1rem;

    .day-picker {
      display: flex;
      gap: 1rem;
    }

    .hour-picker {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      gap: 1rem;
      margin-bottom: 1rem;
    }
  }

  @media screen and (max-width: 768px) {
    .not-all-day-picker {
      .day-picker {
      }

      .hour-picker {
      }
    }
  }
`;
